import type { ExtensionShopifyClient } from "@redotech/shopify-client/ajax";
import { clearRedoLocalStorage, clearRedoSessionStorage } from "./clear-cache";

/**
 * Adds a `redoDebug` function to the window that can be called from the browser console.
 * This method enables debug logging for both the shopify extension and the checkout extension.
 */
export function mountRedoDebugFunction(
  extensionShopifyClient: ExtensionShopifyClient,
) {
  globalThis.redoDebug = async function (enabled: boolean): Promise<void> {
    // Prevents annoying debugging issues where old products eligibility is still in localStorage even when settings are changed.
    // TODO: clear local storage whenever settings are changed
    clearRedoLocalStorage();
    clearRedoSessionStorage();

    // Set a session storage value for the `log` function to read
    sessionStorage?.setItem("redo-debug", String(enabled));

    try {
      // Set (or remove) a cart attribute for the checkout-extension to read
      await extensionShopifyClient.updateCartAttribute({
        attributes: [
          {
            /** @see https://shopify.dev/docs/api/ajax/reference/cart#private-cart-attributes */
            key: "__redo-debug",
            value: enabled ? String(enabled) : "", // Empty string removes the attribute
          },
        ],
      });
    } catch (e) {
      console.error(
        "Error updating redo debug cart attribute. Checkout checkbox will not output debug logs.",
        e,
      );
    }
  };
}

export function log(...args: Parameters<typeof console.log>): void {
  /** sessionStorage is an undeclared identifier in non-browser test environments. */
  if (
    typeof sessionStorage !== "undefined" &&
    sessionStorage.getItem("redo-debug") === "true"
  ) {
    console.log(...args);
  }
}
